/* eslint-disable import/prefer-default-export */
import mapToDictionary from '@src/utils/dictionary'
import type {
  GuardrailSummary,
  Folder
} from '@src/endpoints/openapis/saas-cam-guardrails'
import type { GuardrailsDict } from '../models'
import { forEach } from 'lodash'

export function getNormalizedGuardrails(
  list: GuardrailSummary[]
): GuardrailsDict {
  const guardrails: GuardrailsDict = {}
  forEach(list, item => {
    forEach(item?.folders || [], folder => {
      const items: GuardrailSummary[] = guardrails[folder?.id] || []
      guardrails[folder.id] = [...items, item]
    })
  })
  return guardrails
}

export function getNormalizedGuardrailsFolder(folders: Folder[]) {
  return mapToDictionary<Folder, Folder>({
    array: folders || ([] as Folder[]),
    key: 'id'
  })
}
